import React from 'react'
import {NOT_APPLICABLE} from '../../../../../constants';
const CCRBilateral = ({item,pageJson,translations,translateWordForOption}) => {
  let subAccountLendingLimitOption = () => {
    var status = false;
    if(item.subAccountLendingLimit !== NOT_APPLICABLE){
        status = true;
    }
    return status
  }

  let subAcountBorrowingLimit = () => {
    var status = false;
    if(item.subAcountBorrowingLimit !== NOT_APPLICABLE){
        status = true;
    }
    return status
  }

  if(item !== undefined) {
    return (
      <div className="cc-detail-container gdocs-mleft-25">
        <div className="cc-detail-container__heading">{translations(pageJson.accordion6)}</div>
        <div className="cc-detail-container__content">
          <dl className="cc-detail-container__horizontal-row">
            <dt>{translations(pageJson.limitType)}</dt>
            <dd>{item.limitType !== undefined ? item.limitType.name : ''}</dd>
            <dt>{translations(pageJson.currency)}</dt>
            <dd>{item.currency}</dd>
            <dt>{translations(pageJson.accountLimit)}</dt>
            <dd>{item.subAccountLendingLimit}</dd>

            <dt>{subAccountLendingLimitOption() ? translations(pageJson.lendingLimit) : ''}</dt>
            {
              item.lendingLimitBreachAction !== undefined && subAccountLendingLimitOption()
              ? <dd>{item.lendingLimitBreachAction.name}</dd>
              : <dd>&nbsp;</dd>
            }


            <dt>{translations(pageJson.borrowingLimit)}</dt>
            <dd>{item.subAcountBorrowingLimit}</dd>

            <dt>{subAcountBorrowingLimit() ? translations(pageJson.breachAction): ''}</dt>
            {
              item.borrowingLimitBreachAction !== undefined && subAcountBorrowingLimit()
              ? <dd>{item.borrowingLimitBreachAction.name}</dd>
              : <dd>&nbsp;</dd>
            }

          </dl>
        </div>
      </div>
    )
  }else {
    return null;
  }
}

export default CCRBilateral;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/CCPreview/SweepInstruction/CCRBilateral.js